const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404Image(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.07,249l6.1,18a5.93,5.93,0,0,0,6.36,4l26.79-2.92a5.94,5.94,0,0,0,5.2-5.38l1.66-18.93a4.19,4.19,0,0,0-4.65-4.54l-37.93,4.24A4.21,4.21,0,0,0,265.07,249Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.08,268.53s2.33,72.16,62.57,120.25,143.69,51.54,211.26,56.11S444.38,411.2,452.2,353.38s-43.81-74.79-71.82-140.61-25.52-87.46-84.79-127.94S143.59,69.21,95,138.56,51.08,268.53,51.08,268.53Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.08,268.53s2.33,72.16,62.57,120.25,143.69,51.54,211.26,56.11S444.38,411.2,452.2,353.38s-43.81-74.79-71.82-140.61-25.52-87.46-84.79-127.94S143.59,69.21,95,138.56,51.08,268.53,51.08,268.53Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-76"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 438.63,
    y1: 283.16,
    x2: 42.94,
    y2: 283.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0816245079040527px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.52,167.84c0-2.75,1.27-4.77,4.13-4.77s4.18,2,4.18,4.77v9.66c0,2.75-1.27,4.77-4.18,4.77s-4.13-2-4.13-4.77Zm1.24,9.74c0,2,.81,3.56,2.89,3.56s2.94-1.51,2.94-3.56v-9.82c0-2-.84-3.56-2.94-3.56s-2.89,1.51-2.89,3.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.8,167.84c0-2.75,1.27-4.77,4.12-4.77s4.18,2,4.18,4.77v9.66c0,2.75-1.26,4.77-4.18,4.77s-4.12-2-4.12-4.77Zm1.24,9.74c0,2,.81,3.56,2.88,3.56s2.94-1.51,2.94-3.56v-9.82c0-2-.83-3.56-2.94-3.56s-2.88,1.51-2.88,3.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.06,163.23c2.92,0,4.05,1.84,4.05,4.59v2.05c0,3-1.38,4.47-4.37,4.47h-2.35v7.77h-1.24V163.23Zm-.32,10c2.18,0,3.13-1,3.13-3.26v-2.21c0-2.05-.7-3.37-2.81-3.37h-2.67v8.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.93,167.79v.4h-1.19v-.48c0-2-.75-3.51-2.8-3.51s-2.81,1.49-2.81,3.48c0,4.59,6.82,4.67,6.82,9.87,0,2.72-1.18,4.72-4.07,4.72s-4.07-2-4.07-4.72v-1H147v1c0,2,.78,3.48,2.86,3.48s2.85-1.46,2.85-3.48c0-4.53-6.82-4.61-6.82-9.87,0-2.83,1.24-4.66,4-4.69S153.93,165.07,153.93,167.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,179.74v2.37h-1.21v-2.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.4,179.74v2.37h-1.21v-2.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.77,179.74v2.37h-1.21v-2.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.26,246.67l21.25-50.25h12.75v50.25h5.52v10.62h-5.52v13.49H93.78V257.29H71.26Zm22.52,0V218.73L82,246.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.14,214.26c0-11.89,6.27-18.69,17.74-18.69s17.74,6.8,17.74,18.69v38.67c0,11.9-6.27,18.7-17.74,18.7s-17.74-6.8-17.74-18.7Zm11.68,39.42c0,5.31,2.34,7.33,6.06,7.33s6.06-2,6.06-7.33V213.52c0-5.31-2.34-7.33-6.06-7.33s-6.06,2-6.06,7.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.4,246.67l21.25-50.25H189.4v50.25h5.52v10.62H189.4v13.49H177.92V257.29H155.4Zm22.52,0V218.73l-11.79,27.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.38,288.64c2.86,0,4,1.8,4,4.49v2c0,2.93-1.35,4.39-4.28,4.39h-2.3v7.6H72.55V288.64Zm-.31,9.78c2.14,0,3.06-1,3.06-3.2v-2.17c0-2-.68-3.3-2.75-3.3H73.77v8.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6,303l-.93,4.09h-1.1l4-18.52h1.77l4.12,18.52H90.28L89.36,303Zm.18-1.06h5.39l-2.72-12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,293.16v1.37h-1.17v-1.45c0-2-.76-3.49-2.8-3.49s-2.8,1.51-2.8,3.49v9.62c0,2,.77,3.46,2.8,3.46s2.8-1.48,2.8-3.46v-4H97.61V297.6h3.62v5c0,2.67-1.17,4.67-4,4.67s-4-2-4-4.67v-9.46c0-2.67,1.16-4.68,4-4.68S101.23,290.49,101.23,293.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.52,297.2v1.11h-5V306h6.07v1.1h-7.29V288.64h7.29v1.11h-6.07v7.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.74,307.13h-1.11V288.64h1.59l5.55,15.61V288.64h1.11v18.49h-1.35l-5.79-16.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.89,293.16c0-2.7,1.24-4.68,4-4.68s4.09,2,4.09,4.68v9.46c0,2.69-1.24,4.67-4.09,4.67s-4-2-4-4.67Zm1.21,9.54c0,2,.79,3.48,2.83,3.48s2.88-1.48,2.88-3.48v-9.62c0-2-.82-3.49-2.88-3.49s-2.83,1.48-2.83,3.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.15,307.13V289.75H136.4v-1.11h8.74v1.11h-3.77v17.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.75,297.65v1.11H152v8.37h-1.21V288.64h7v1.11H152v7.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.55,293.16c0-2.7,1.24-4.68,4-4.68s4.1,2,4.1,4.68v9.46c0,2.69-1.25,4.67-4.1,4.67s-4-2-4-4.67Zm1.21,9.54c0,2,.8,3.48,2.83,3.48s2.88-1.48,2.88-3.48v-9.62c0-2-.82-3.49-2.88-3.49s-2.83,1.48-2.83,3.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.86,302.67c0,2,.74,3.51,2.77,3.51s2.78-1.53,2.78-3.51v-14h1.13v14c0,2.64-1.11,4.67-3.93,4.67s-4-2-4-4.67v-14h1.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.74,307.13h-1.11V288.64h1.59l5.55,15.61V288.64h1.11v18.49h-1.35l-5.79-16.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,288.64c2.86,0,4.1,1.88,4.1,4.6v9.3c0,2.72-1.24,4.59-4.1,4.59H190V288.64ZM194,306c2.06,0,2.9-1.41,2.9-3.44v-9.41c0-2-.87-3.43-2.9-3.43h-2.83V306Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.66,82.14s0-4.94-6.91-11.84S397.4,59.44,397.4,59.44s-3.45,11.35,3,18.26A122.32,122.32,0,0,0,415.66,91Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.63,113s0-4.94-6.9-11.84-11.35-10.86-11.35-10.86-3.45,11.35,3,18.26a121.81,121.81,0,0,0,15.29,13.32Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.22,90.54s.53-4.91,8.12-11.05,12.43-9.59,12.43-9.59S438,81.55,430.9,87.74a121.71,121.71,0,0,1-16.61,11.63Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.11,126.93s1-4.83,9.24-10.14,13.37-8.23,13.37-8.23,1,11.82-6.72,17.23a121.33,121.33,0,0,1-17.75,9.82Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.39,166.6s0-4.94,6.91-11.84,11.34-10.86,11.34-10.86,3.46,11.35-3,18.26a121.81,121.81,0,0,1-15.29,13.32Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.28,176.28s.7-4.88-5.16-12.7-9.69-12.36-9.69-12.36-5,10.74.34,18.49A121.74,121.74,0,0,0,404,185.07Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.47,205s0-4.93,6.9-11.84,11.35-10.86,11.35-10.86,3.45,11.35-3,18.26a120.87,120.87,0,0,1-15.29,13.32Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.08,231s-1.25-4.78,3.68-13.21S415,204.42,415,204.42s6.21,10.1,1.76,18.41a122.35,122.35,0,0,1-11.42,16.76Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.28,80.87a139.43,139.43,0,0,1-1.89,15.32c-2.73,14.11-9.55,23.21-12.28,35.95s5.1,29.15,3,45.52-8.46,25.46-6.64,36.39,11.37,40.49,11.37,40.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.16,
    y1: 93.82,
    x2: 422.6,
    y2: 88.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.5,
    y1: 87.24,
    x2: 412.39,
    y2: 81.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.52,131.55s6.23-4.67,12.64-9.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.63,121.83s-5.19-10.18-11.07-16.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.64,173.62A77,77,0,0,1,419,155.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.42,180.54a86.78,86.78,0,0,0-6.75-12.81c-3.63-5.37-4.15-6.06-4.15-6.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.47,214.05a82.12,82.12,0,0,1,5.61-11.35,72.05,72.05,0,0,1,7.27-9.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.33,239.59a21.19,21.19,0,0,1,1.86-10.93c2.6-5,5.54-11.6,6.75-14.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.43,148s-.54-3.09,3.05-8.17,5.93-8,5.93-8,3.4,6.74.13,11.77a76.51,76.51,0,0,1-8.15,10Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.06,166.28s-.54-3.1,3.05-8.18,5.93-8,5.93-8,3.4,6.74.13,11.77a76.51,76.51,0,0,1-8.15,10Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.61,153.27s-.86-3-6.29-6.05-8.83-4.67-8.83-4.67-.14,7.55,5,10.66a77.4,77.4,0,0,0,11.68,5.49Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.16,174.77s-1.17-2.91-6.89-5.35-9.28-3.71-9.28-3.71.66,7.52,6.08,10.07a77.72,77.72,0,0,0,12.2,4.23Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,199.89s-.54-3.09-5.62-6.67-8.29-5.58-8.29-5.58-.94,7.49,3.83,11.13a78.05,78.05,0,0,0,11,6.69Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.16,206s-1-3,1.85-8.52,4.74-8.8,4.74-8.8,4.32,6.19,1.79,11.63a77.27,77.27,0,0,1-6.63,11.07Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.83,230.91s.36-3.12,5.23-7,8-6,8-6,1.36,7.43-3.2,11.33a77,77,0,0,1-10.63,7.31Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.55,223.21s-.54-3.09-5.62-6.68-8.29-5.57-8.29-5.57-.94,7.49,3.83,11.13a78.05,78.05,0,0,0,11,6.69Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.48,240s.26-3.13-3.74-7.88-6.61-7.5-6.61-7.5-2.81,7,.89,11.74a78.12,78.12,0,0,0,9,9.27Z",
    style: {
      fill: "#219297"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.9,147.32a89.48,89.48,0,0,0,2.85,9.4c3.24,8.55,8.51,13.51,11.61,21.21s0,18.84,3.05,28.87,8.08,15,8.12,22.09-2.74,26.64-2.74,26.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.01,
    y1: 155.31,
    x2: 366.73,
    y2: 152.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.08,
    y1: 151.23,
    x2: 372.43,
    y2: 147.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,177.61s-4.41-2.26-8.94-4.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,171.84A63.07,63.07,0,0,1,386.13,160",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.65,204.32a49.28,49.28,0,0,0-10.3-9.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.16,208.53a55,55,0,0,1,2.84-8.76c1.7-3.76,1.95-4.25,1.95-4.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.29,234.24a46,46,0,0,1,5.69-5.9,30.62,30.62,0,0,0,3.69-3.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.53,228.89a52.72,52.72,0,0,0-4.75-6.5,46.33,46.33,0,0,0-5.59-5.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,245.66a13.38,13.38,0,0,0-2.36-6.65c-2.17-2.87-4.73-6.67-5.77-8.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.48,289.2H386.07a2.88,2.88,0,0,1-2.87-2.87l-4.52-34.22h45.18l-4.51,34.22A2.88,2.88,0,0,1,416.48,289.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.47,258H378.68a3.53,3.53,0,0,1-3.53-3.53h0a3.53,3.53,0,0,1,3.53-3.54h44.79a3.54,3.54,0,0,1,3.54,3.54h0A3.54,3.54,0,0,1,423.47,258Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.32,329.29a4.71,4.71,0,0,1-4.24-6.78A8,8,0,0,0,372.91,312c-7.06-4.52-23.48-5.24-29.23-5.15h-.08a4.72,4.72,0,0,1-.09-9.44c2.41-.05,23.76-.22,34.48,6.64,10.57,6.77,8.93,17.71,6.58,22.56A4.73,4.73,0,0,1,380.32,329.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.08 354.19 401.04 357.72 385.29 331.82 384.88 326.23 402.08 354.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.04 357.72 405.96 355.29 406.84 351.92 402.08 354.19 401.04 357.72",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.81 323.33 401.04 322.7 406.84 351.92 402.08 354.19 382.81 323.33",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.32 324.57 398.55 355.23 392.55 358.13 365.61 336.17 380.32 324.57",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.55 358.13 391.72 361.24 364.58 339.69 365.61 336.17 392.55 358.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.55 358.13 398.55 355.23 397.73 358.34 391.72 361.24 392.55 358.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.9,
    cy: 329.09,
    r: 9.24,
    transform: "translate(-120.26 367.85) rotate(-45)",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.17 354.19 190.21 357.72 205.95 331.82 206.37 326.23 189.17 354.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.21 357.72 185.29 355.29 184.41 351.92 189.17 354.19 190.21 357.72",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.44 323.33 190.21 322.7 184.41 351.92 189.17 354.19 208.44 323.33",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.93 324.57 192.69 355.23 198.7 358.13 225.63 336.17 210.93 324.57",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.7 358.13 199.53 361.24 226.67 339.69 225.63 336.17 198.7 358.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.7 358.13 192.69 355.23 193.52 358.34 199.53 361.24 198.7 358.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.94,332.43a4.72,4.72,0,0,1-3-8.38c37.52-30.53,29.88-76.06,29.8-76.52a4.72,4.72,0,0,1,9.29-1.66c.37,2.09,8.66,51.5-33.13,85.5A4.7,4.7,0,0,1,207.94,332.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.5,
    cy: 234.51,
    r: 18.48,
    transform: "translate(-25.97 438.53) rotate(-80.83)",
    style: {
      fill: "#adadad",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.34,
    cy: 329.09,
    r: 9.24,
    transform: "translate(-171.97 243) rotate(-45)",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 293.99,
    cy: 283.27,
    rx: 29.33,
    ry: 27.36,
    style: {
      fill: "#adadad",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.71,271.58l2.74,10.69a11.76,11.76,0,0,0,12.69,8.23h0a11.74,11.74,0,0,0,10.27-11.08l.54-10.78Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.53,217.79a27.51,27.51,0,0,1-8.18-1.12l.76-2.23c.13,0,13.26,4.27,26.63-5.51l1.39,1.91A34.54,34.54,0,0,1,336.53,217.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.27,235.53c-10.82-15.81-23.13-14.62-23.25-14.61l-.26-2.34c.56-.06,13.85-1.35,25.45,15.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.53,246.7c-14-4.31-22.41-22.95-22.77-23.74l2.16-1c.08.19,8.34,18.45,21.31,22.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.81,
    y1: 210.52,
    x2: 359.59,
    y2: 208,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.19,
    y1: 232.77,
    x2: 353.71,
    y2: 237.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.78,244.73a27.5,27.5,0,0,0,6.09.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.63 214.32 244.12 238.73 330.97 229.85 330.65 204.49 240.63 214.32",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.12 238.73 259.65 278.03 326.53 271.37 330.97 229.85 244.12 238.73",
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.07,249l6.1,18a5.93,5.93,0,0,0,6.36,4l26.79-2.92a5.94,5.94,0,0,0,5.2-5.38l1.66-18.93a4.19,4.19,0,0,0-4.65-4.54l-37.93,4.24A4.21,4.21,0,0,0,265.07,249Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-76)"
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "265.07 258.89 276.13 257.91 279.64 248.38 287.9 263.23 292.1 252.16 294.2 255.67 314.24 253.28",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M265.07,249l6.1,18a5.93,5.93,0,0,0,6.36,4l26.79-2.92a5.94,5.94,0,0,0,5.2-5.38l1.66-18.93a4.19,4.19,0,0,0-4.65-4.54l-37.93,4.24A4.21,4.21,0,0,0,265.07,249Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.89,
    cy: 241.32,
    r: 4.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.85,256.52a4.56,4.56,0,1,1-4.56-4.56A4.56,4.56,0,0,1,324.85,256.52Z",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.72,246.6a4.86,4.86,0,1,1-6.06-3.25A4.85,4.85,0,0,1,261.72,246.6Z",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.87,
    cy: 262.73,
    r: 4.56,
    transform: "translate(-101.55 338.44) rotate(-57)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.37,
    cy: 302.72,
    rx: 12.92,
    ry: 12.46,
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.37,330.68l11.83-26.56a5.09,5.09,0,0,1,6.17-2.79h0a5.09,5.09,0,0,1,3.47,6l-7.79,34.92Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.42,290l25.83,60.79-31,4.26s-18.54-18.85-31-54.71Z",
    style: {
      fill: "#adadad",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.42 289.95 254.63 284.18 280.47 346.18 279.25 350.74 253.42 289.95",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.63 284.18 219.38 294.81 217.25 300.29 253.42 289.95 254.63 284.18",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 219.68,
    y1: 306.06,
    x2: 255.24,
    y2: 295.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.41,
    y1: 312.44,
    x2: 258.28,
    y2: 302.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.15,
    y1: 319.13,
    x2: 261.32,
    y2: 309.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.1,
    y1: 327.34,
    x2: 264.36,
    y2: 317,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.84,
    y1: 333.86,
    x2: 268.01,
    y2: 324.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.7,
    y1: 339.82,
    x2: 271.05,
    y2: 331.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 241.15,
    y1: 345.55,
    x2: 273.17,
    y2: 337.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.3,
    y1: 350.23,
    x2: 276.11,
    y2: 344.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 310.78,
    cy: 302.72,
    rx: 12.92,
    ry: 12.46,
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.77,330.68l-11.83-26.56a5.09,5.09,0,0,0-6.17-2.79h0a5.08,5.08,0,0,0-3.46,6l7.79,34.92Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.73,290l-25.84,60.79,31,4.26s18.54-18.85,31-54.71Z",
    style: {
      fill: "#adadad",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.73 289.95 332.51 284.18 306.67 346.18 307.89 350.74 333.73 289.95",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.51 284.18 367.77 294.81 369.9 300.29 333.73 289.95 332.51 284.18",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 367.46,
    y1: 306.06,
    x2: 331.9,
    y2: 295.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364.73,
    y1: 312.44,
    x2: 328.86,
    y2: 302.72,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.99,
    y1: 319.13,
    x2: 325.82,
    y2: 309.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 358.04,
    y1: 327.34,
    x2: 322.78,
    y2: 317,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 354.3,
    y1: 333.86,
    x2: 319.14,
    y2: 324.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350.44,
    y1: 339.82,
    x2: 316.1,
    y2: 331.59,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 346,
    y1: 345.55,
    x2: 313.97,
    y2: 337.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 342.84,
    y1: 350.23,
    x2: 311.03,
    y2: 344.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.28,
    y1: 238.01,
    x2: 360.64,
    y2: 239.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.18,
    y1: 239.27,
    x2: 358.54,
    y2: 244.52,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 353.29,
    y1: 239.48,
    x2: 352.66,
    y2: 242.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 361.48,
    y1: 217.65,
    x2: 369.66,
    y2: 217.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.18,
    y1: 218.07,
    x2: 366.93,
    y2: 221.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 359.59,
    y1: 213.67,
    x2: 367.14,
    y2: 212.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 332.51,
    y1: 239.69,
    x2: 334.61,
    y2: 245.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335.24,
    y1: 239.27,
    x2: 341.11,
    y2: 248.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.34,
    y1: 233.61,
    x2: 343,
    y2: 235.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.61 230.46 366.72 232.52 368.09 234.96 365.54 233.79 363.65 235.85 363.97 233.07 361.43 231.9 364.17 231.35 364.5 228.57 365.87 231.01 368.61 230.46",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5408122539520264px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.55 202.75 369.65 204.81 371.03 207.25 368.48 206.08 366.59 208.14 366.91 205.36 364.37 204.19 367.11 203.64 367.43 200.86 368.81 203.3 371.55 202.75",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5408122539520264px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.9 251.24 339.01 253.3 340.38 255.74 337.84 254.57 335.94 256.63 336.26 253.85 333.72 252.68 336.46 252.13 336.79 249.35 338.16 251.79 340.9 251.24",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5408122539520264px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.3,
    cy: 191.5,
    rx: 14.11,
    ry: 13.95,
    style: {
      fill: "#adadad",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.79,
    cy: 187.69,
    rx: 14.11,
    ry: 13.95,
    style: {
      fill: "#adadad",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.42,
    cy: 217.01,
    rx: 17.75,
    ry: 16.96,
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.43,208.3l2.45,10.76a11.73,11.73,0,0,0,12.45,8.57h0a11.75,11.75,0,0,0,10.58-10.79l.83-10.76Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.26 162.97 247.61 189.6 313.85 184.21 304.03 158.85 254.26 162.97",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.61 189.6 259.33 218.76 311.32 213.69 313.85 184.21 247.61 189.6",
    style: {
      fill: "#e5e5e5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.4,201.49c-.18,4.14-3.8,7.4-8.13,7.73s-8.57-2.38-9.5-6.48c-1-4.7,2.51-9.32,8.06-9.67S277.59,196.77,277.4,201.49Z",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.09,201.72a5.22,5.22,0,0,1-5,5,5.45,5.45,0,0,1-5.9-4.21c-.49-2.84,1.74-5.51,5-5.73A5.32,5.32,0,0,1,274.09,201.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.87,198.64c-.17,4.14-3.79,7.4-8.12,7.73s-8.58-2.38-9.5-6.49c-1.05-4.69,2.51-9.31,8.06-9.67S307.07,193.92,306.87,198.64Z",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.56,198.87a5.21,5.21,0,0,1-5,5,5.46,5.46,0,0,1-5.9-4.22c-.49-2.84,1.74-5.5,5-5.72A5.3,5.3,0,0,1,303.56,198.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.72,213.51a2.36,2.36,0,0,1-.24-4.71l12.68-1.27a2.36,2.36,0,0,1,.47,4.7L278,213.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.48,
    cy: 171.28,
    r: 4.79,
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.52,
    cy: 168.49,
    r: 4.09,
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.73,164.14a3.22,3.22,0,1,1-3.22-3.23A3.22,3.22,0,0,1,251.73,164.14Z",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 247.73,
    y1: 163.01,
    x2: 240.41,
    y2: 156.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 302.52,
    cy: 167.97,
    r: 4.79,
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.48,
    cy: 165.18,
    r: 4.09,
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.27,160.83a3.22,3.22,0,1,0,3.22-3.23A3.22,3.22,0,0,0,306.27,160.83Z",
    style: {
      fill: "#219297",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.27,
    y1: 159.69,
    x2: 317.59,
    y2: 152.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.55,335.58c0,2.31-1.53,4.18-3.42,4.18s-3.41-1.87-3.41-4.18,1.53-4.18,3.41-4.18S299.55,333.27,299.55,335.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.31,339.08l-.26,0-9.49-1.39a1.77,1.77,0,0,1,.51-3.5l9.49,1.38a1.77,1.77,0,0,1-.25,3.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.68,355.12c-1.24-1.95-1-4.35.64-5.35s3.88-.25,5.12,1.69.95,4.35-.65,5.36S174.91,357.07,173.68,355.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.09,355.79a1.67,1.67,0,0,1,.23-.12l8.76-3.91a1.77,1.77,0,0,1,1.44,3.23l-8.76,3.91a1.77,1.77,0,0,1-1.67-3.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.31,310.32c-1.24-1.95-.95-4.34.64-5.35s3.88-.25,5.12,1.69.95,4.35-.64,5.36S401.54,312.27,400.31,310.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.73,311l.22-.12,8.76-3.91a1.77,1.77,0,1,1,1.44,3.23l-8.75,3.91a1.77,1.77,0,0,1-1.67-3.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.18,357c-4,0-7.22,1.92-7.22,4.28s3.23,4.28,7.22,4.28,7.23-1.92,7.23-4.28S235.17,357,231.18,357Zm0,6.49c-2.06,0-3.73-1-3.73-2.21s1.67-2.21,3.73-2.21,3.74,1,3.74,2.21S233.25,363.49,231.18,363.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.26,357.69l-4.93-2-4.94,2-1.22,4.4,3.42,3.53h5.48l3.41-3.53Zm-3.54,5.62h-2.78l-1.74-1.79.62-2.23,2.51-1,2.5,1,.62,2.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.82,293.8l-4.94-2-4.94,2-1.22,4.41,3.42,3.53h5.48l3.42-3.53Zm-3.55,5.63h-2.78l-1.73-1.79.61-2.24,2.51-1,2.51,1,.62,2.24Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.27,367.73a1.22,1.22,0,0,1-.41-.07,3.5,3.5,0,0,1-1.62-1.39c-.55-.85-1-2.36-.13-4.7a5.54,5.54,0,0,1,3.85-3.51,7.52,7.52,0,0,1,6.53,1.49,1.17,1.17,0,0,1,.16,1.66,1.18,1.18,0,0,1-1.66.16,5.2,5.2,0,0,0-4.42-1,3.24,3.24,0,0,0-2.25,2.07c-.89,2.35.18,3,.4,3.06a1.2,1.2,0,0,1,.63,1.53A1.16,1.16,0,0,1,329.27,367.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.65,372.07a3.55,3.55,0,0,1-1.1-.17l-19.19-6.25a3.54,3.54,0,1,1,2.19-6.73l19.2,6.25a3.54,3.54,0,0,1-1.1,6.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.78,365.49s.76-4.88,6.86-5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.89,366.55s.77-4.87,6.86-5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.55,367.92s.76-4.87,6.85-5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.36,369s.76-4.87,6.85-5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.17,370.36s.76-4.87,6.85-5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.64,372a1.14,1.14,0,0,1-.4-.08,3.46,3.46,0,0,1-1.63-1.38c-.55-.85-1-2.36-.13-4.71a5.58,5.58,0,0,1,3.85-3.51,7.52,7.52,0,0,1,6.53,1.5,1.17,1.17,0,0,1,.16,1.66,1.18,1.18,0,0,1-1.66.16,5.19,5.19,0,0,0-4.42-1,3.21,3.21,0,0,0-2.25,2.06c-.89,2.36.18,3,.4,3.06a1.19,1.19,0,0,1-.45,2.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0816245079040527px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Image);
export default __webpack_public_path__ + "static/media/404-image.1c27f9c2ba00372be3d780aaee913267.svg";
export { ForwardRef as ReactComponent };